import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Select } from '@components/core-ui/form-elements/Select';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { useAPI } from '@providers/useAPI';
import { useMutation } from '@tanstack/react-query';
import { SubscriptionsService } from 'app/API';
import { notifyApiCallError } from 'app/http/notifyApiCallError';
import { useState } from 'react';
import { Wrapper } from './styles/Wrapper';
import { TProps } from './types/TProps';

export const UpdateLicenseBackupRecordingFlag = ({ baId, licenseId, initialValue, onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const [value, setValue] = useState(initialValue ? 'on' : 'off');

  const values = [
    { label: 'On', value: 'on' },
    { label: 'Off', value: 'off' },
  ];

  const updateMutation = useMutation({
    mutationFn: () =>
      call(() =>
        SubscriptionsService.updateLicenseBackupRecordingFlag({
          baId,
          licenseId,
          requestBody: { asOneBackupRecordingAllowed: value === 'on' },
        }),
      ),
    onSuccess: () => {
      onSuccess();
      onCancel();
    },
    onError: notifyApiCallError,
  });

  const isSubmitting = updateMutation.isPending;

  return (
    <Wrapper>
      <ModalWrapper width="400px" overflow="visible">
        {isSubmitting ? <AbsoluteSpinner overlay={true} /> : null}
        <ModalTitle>Update license backup recording flag</ModalTitle>

        <Select
          name="value"
          label="Backup Recording Enabled"
          className="form-select"
          value={value}
          onChange={(_, value) => setValue(value)}
          options={values}
        />

        <div className="buttonGroup">
          <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
          <Button onClick={() => updateMutation.mutate()} disabled={isSubmitting}>
            Update
          </Button>
        </div>
      </ModalWrapper>
    </Wrapper>
  );
};
